import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import { backToOffers } from "containers/MultistepForm/actions";
import { logEvent } from "containers/EmbeddableWidget/actions";
import "./styles.scss";

class UownUnavailableScreen extends Component {
  handleBackToOffers = () => {
    const { backToOffers, logEvent } = this.props;
    backToOffers();
    logEvent({ name: "view other options" });
  };

  render() {
    return (
      <div className="expanded-block-component bank-data-form-container">
        <div className="bank-data-form-header uown-unavailable-header">
          <div className="uown-unavailable-icon">
            <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="16" x2="12" y2="12"/>
              <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
          </div>
          
          <h1>This option isn't available</h1>
          
          <p>
            Unfortunately Uown couldn't approve this application, but you still have other options.
          </p>

          <div className="uown-unavailable-nudge">
            <svg className="uown-unavailable-nudge-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
            <span className="uown-unavailable-nudge-text">
              Other offers may still be available for your order — let's find one that works.
            </span>
          </div>

          <div className="uown-unavailable-legal">
            <p>
              In accordance with the ECOA and FCRA, you may request the reason for this decision. You will receive an email with instructions within 60 days.
            </p>
            <p className="uown-unavailable-reason">
              <strong>Detail:</strong> Uown was unable to approve your pre-qualified application.
            </p>
          </div>
        </div>

        <div className="footer">
          <BlueBtn onClick={this.handleBackToOffers}>
            Select Another Offer
          </BlueBtn>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    backToOffers: () => dispatch(backToOffers()),
    logEvent: (value) => dispatch(logEvent(value)),
  };
};

export default connect(null, mapDispatchToProps)(UownUnavailableScreen);